import { Navigate, useParams } from 'react-router-dom'

/**
 * `/poll/:eventId/:token` → `/event/:eventId`, permanently.
 *
 * The standalone voting page this path used to render (`DatePollPage`) is
 * gone. It demanded a row in `event_invites` with `invite_type = 'poll'`, and
 * nothing in this repository has ever written one — 0 rows in production — so
 * the page could only ever show «finnes ikke». Voting moved to `DatePollCard`
 * on the event's own overview (PR #141), which is where this sends the link.
 *
 * The token is dropped on purpose: it never resolved to anything, and the
 * event page decides on its own whether the viewer gets in. A stale link
 * should land on the event, never on a 404.
 */
export function PollRedirect() {
  const { eventId } = useParams<{ eventId: string }>()
  return <Navigate to={`/event/${eventId}`} replace />
}
